var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasImage)?_c('v-img',{style:(_vm.style),attrs:{"src":_vm.imageUrl,"width":_vm.width,"height":_vm.height}}):_c('v-img',{style:(_vm.style),attrs:{"src":_vm.defaultImage,"width":_vm.width}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }